import React, {useState} from 'react'
import {Button, Checkbox, message, Modal} from 'antd'
import {getHasPermissions, assignAllpermissions, unAssignAllPermissions} from "../../services/serviceRolePermission";
import RolePermissionItems from "./RolePermissionItems";
import config from "../../config";

const RolePermission = ({roleId, updater}) => {
    const [permissionModal, setPermissionModal] = useState(false)
    const [permissionList, setPermissionList] = useState({})


    const handlePermissionClick = () => {
        if (config.protectedVariables.roleId.includes(roleId)){
            message.error('Bu işlem yapılamaz')
        }else {
            getHasPermissions(roleId)
                .then((data) => {
                    setPermissionList(data)
                    setPermissionModal(!permissionModal)
                })
        }
    }

    const handleModalClose = () => {
        setPermissionModal(!permissionModal)
    }
    const setAll = (value) => {
        if (value.target.checked){
            assignAllpermissions(roleId)
                .then(({data}) => data)
        }else{
            unAssignAllPermissions(roleId)
                .then(({data}) => data)
        }
    }

    return (
        <React.Fragment>
            <Button
                onClick={() => handlePermissionClick()}
            >
               Yetkilendir
            </Button>
            <Modal
                open={permissionModal}
                closable={false}
                title={'İzin Listesi'}
                footer={[
                    <Button type={'primary'}
                            key={'SubmitButton'}
                            onClick={() => handleModalClose()}
                    >Kaydet</Button>,
                    <Button  key={'CancelButton'} onClick={() => handleModalClose()} >Kapat</Button>
                ]}
            >
                <Checkbox onChange={setAll}>Hepsini Ata</Checkbox>

                    {Object.keys(permissionList).map((key) => {
                        let item = permissionList[key]
                        return <RolePermissionItems key={key} headers={key}  roleId={roleId} permissionList={item}/>

                    })}
            </Modal>
        </React.Fragment>
    )
}
export default RolePermission